export default class Base64 {
  constructor(element) {
    this.containerDOM = document.getElementById(element)
  }

  updateTransform() {
    //
  }
}
